import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { CreditCardValidators } from 'angular-cc-library';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { UpdatePaymentDetailsRequest, MyAccountConsumer, MyAccountPaymentDetail, PaymentPlanCode, } from '../../../../model/account/update-payment-details-request';
import { _MatCheckboxRequiredValidatorModule } from '@angular/material/checkbox';
import { PreInitSettingsService } from '../../../../core/services/settings/pre-init-setting.service';
import { ISelectedContract } from 'src/app/core/services/settings/logged-in-user-settings';
import { UUID } from 'angular2-uuid';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMApiStatus, GTMEvents } from 'src/app/model/google-tag-manager/api-status';
import { STATES } from 'src/app/core/constants/common.constants';
import { BillingProfileDataService } from 'src/app/core/services/billing-profile-data.service';
import { finalize } from 'rxjs/operators';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { Platform } from '@angular/cdk/platform';
import { isAfter } from 'date-fns';
import { PGHCreditCardDateAdapter } from 'src/app/shared/pghCreditCardDateAdapter';
import getYear from 'date-fns/getYear';
import getMonth from 'date-fns/getMonth';
import PlaceResult = google.maps.places.PlaceResult;
import { ADPResourceService } from 'digital-core';

export enum PAYMENT_OPTIONS {
  CREDIT_CARD = 'CreditCard',
  ECHECK = 'eCheck'
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'pgh-billing-info',
  templateUrl: './billing-info.component.html',
  styleUrls: ['./billing-info.component.scss'],
  providers: [{
    provide: DateAdapter,
    useClass: PGHCreditCardDateAdapter,
    deps: [MAT_DATE_LOCALE, Platform],
  },
  { 
    provide: MAT_DATE_FORMATS, useValue: MY_FORMATS
  }]
})
export class BillingInfoComponent implements OnInit {
  readonly PAYMENT_OPTIONS = PAYMENT_OPTIONS;
  @Input() selectedContract: ISelectedContract;
  @Input() user: UserClaims;
  @Input() updatePaymentMessage: any;
  @Output() updatePaymentMessageChange = new EventEmitter();
  isClicked: boolean = false;

  get creditCardType() {
    const cardNumber = this.paymentFormGroup?.get('cardNumber')?.value;
    if (cardNumber?.length >= 4) {
      switch (parseInt(cardNumber.substr(0, 1), 0)) {
        case 3:
          return 'AMEX';
        case 4:
          return 'VISA';
        case 5:
          return 'MC';
        case 6:
          return 'DISCOVER';
      }
    }
    return;
  }
  minDate: Date = new Date();
  maxDate: Date;
  paymentInfoData: any;
  paymentFormGroup: UntypedFormGroup;
  states = STATES.map(x => ({ Key: x, Value: x }));
  isLoading = true;
  selectedPaymentOption = PAYMENT_OPTIONS.CREDIT_CARD;
  paymentMessageType: 'SUCCESS' | 'ERROR';
  paymentMessage: string;
  paymentMessageTitle: string;
  defaultAddress = '';
  programCode: string;
  clientId: string;
  associateNumber: string;
  trackingId = UUID.UUID();

  constructor(
    private billingProfileDataService: BillingProfileDataService,
    private preInitSettingsService: PreInitSettingsService,
    private resourceService: ADPResourceService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.programCode = this.preInitSettingsService.getSettings().middleWare.programCode;
    this.clientId = this.preInitSettingsService.getSettings().middleWare.clientId;
    this.associateNumber = this.preInitSettingsService.getSettings().middleWare.associateNumber;
    this.maxDate = new Date(this.minDate.getFullYear() + 20, this.minDate.getMonth(), this.minDate.getDate());
    this.paymentFormGroup = new UntypedFormGroup({
      BillingAddress1: new UntypedFormControl('', [Validators.required, Validators.maxLength(30)]),
      BillingAddress2: new UntypedFormControl(''),
      City: new UntypedFormControl('', [Validators.required]),
      State: new UntypedFormControl('', Validators.required),
      ZipCode: new UntypedFormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
      PaymentType: new UntypedFormControl(PAYMENT_OPTIONS.CREDIT_CARD),
      Name: new UntypedFormControl('', [Validators.required]),
      CardNumber: new UntypedFormControl('', [Validators.required, CreditCardValidators.validateCCNumber]),
      ExpirationDate: new UntypedFormControl('', [Validators.required, this.validateMinDate.bind(this)]),
      CvvCode: new UntypedFormControl('', [Validators.required, this.validateCcv.bind(this)]),
      AccountNumber: new UntypedFormControl('', [Validators.required, Validators.minLength(10)]),
      RoutingNumber: new UntypedFormControl('', [Validators.required, Validators.minLength(9)]),
      PaymentConsent: new UntypedFormControl(false, [Validators.requiredTrue])
    });

    this.paymentFormGroup.get('PaymentType').valueChanges.subscribe(value => {
      // if (value === PAYMENT_OPTIONS.CREDIT_CARD) {
      this.selectedPaymentOption = PAYMENT_OPTIONS.CREDIT_CARD;
      this.paymentFormGroup.get('Name').setValidators([Validators.required, Validators.maxLength(19), Validators.minLength(1)]);
      this.paymentFormGroup.get('CardNumber').setValidators([Validators.required, CreditCardValidators.validateCCNumber]);
      this.paymentFormGroup.get('ExpirationDate').setValidators([Validators.required, this.validateMinDate.bind(this)]);
      this.paymentFormGroup.get('CvvCode').setValidators([Validators.required, this.validateCcv.bind(this)]);
      this.paymentFormGroup.get('AccountNumber').setValidators(null);
      this.paymentFormGroup.get('RoutingNumber').setValidators(null);
      //   } else {
      //     // this.typeCard = 0;
      //     this.selectedPaymentOption = PAYMENT_OPTIONS.ECHECK;
      //     this.paymentFormGroup.get('name').setValidators(null);
      //     this.paymentFormGroup.get('cardNumber').setValidators(null);
      //     this.paymentFormGroup.get('expirationDate').setValidators(null);
      //     this.paymentFormGroup.get('cvvCode').setValidators(null);
      //     this.paymentFormGroup.get('accountNumber').setValidators([Validators.required, Validators.minLength(10)]);
      //     this.paymentFormGroup.get('routingNumber').setValidators([Validators.required, Validators.minLength(9)]);
      //   }

      //   this.paymentFormGroup.get('name').updateValueAndValidity();
      //   this.paymentFormGroup.get('cardNumber').updateValueAndValidity();
      //   this.paymentFormGroup.get('expirationDate').updateValueAndValidity();
      //   this.paymentFormGroup.get('cvvCode').updateValueAndValidity();
      //   this.paymentFormGroup.get('accountNumber').updateValueAndValidity();
      //   this.paymentFormGroup.get('routingNumber').updateValueAndValidity();
    });

    this.paymentFormGroup.get('PaymentType').setValue(this.selectedPaymentOption);

    this.getBillingInfo();
    this.paymentFormGroup?.get('CardNumber').valueChanges.subscribe(val => {
      this.isClicked = false;
    });
  }

  getBillingInfo() {
    this.isLoading = true;
    this.billingProfileDataService.getPaymentInfo(
      this.selectedContract.zipCode,
      this.programCode,
      this.selectedContract.id,
      this.clientId,
      this.trackingId,
      this.associateNumber
    )
      .pipe(finalize(() => {
        const element = document.querySelector('.payment-hero');
        element.scrollIntoView({ behavior: 'smooth' });
      })).subscribe({
        next: data => {
          this.paymentInfoData = data;
          this.paymentInfoData.contractNumber = this.selectedContract.id;
          if (this.paymentInfoData.Addresses?.length) {
            this.defaultAddress = this.paymentInfoData.Addresses[0].Address1;
            this.paymentFormGroup.get('BillingAddress1').setValue(this.paymentInfoData.Addresses[0].Address1);
            this.paymentFormGroup.get('BillingAddress2').setValue(this.paymentInfoData.Addresses[0].Address2);
            this.paymentFormGroup.get('City').setValue(this.paymentInfoData.Addresses[0].City);
            this.paymentFormGroup.get('State').setValue(this.paymentInfoData.Addresses[0].State);
            this.paymentFormGroup.get('ZipCode').setValue(this.paymentInfoData.Addresses[0].ZipCode);
            this.paymentFormGroup.get('Name').setValue(this.paymentInfoData.Name);
            this.paymentFormGroup.get('CardNumber').setValue(this.paymentInfoData.CreditCardNumber);
            // if (this.paymentInfoData.PaymentMethod === 1 && !this.paymentInfoData.IsAmountOverDue) {
            //   this.selectedPaymentOption = PAYMENT_OPTIONS.ECHECK;
            // } else {
            //   this.selectedPaymentOption = PAYMENT_OPTIONS.CREDIT_CARD;
            // }
            this.paymentFormGroup.get('PaymentType').setValue(this.selectedPaymentOption);
          }

          if (this.paymentInfoData.IsAmountOverDue) {
            this.updatePaymentMessageChange.emit({
              title: this.getLabel('Account_Payment_Error_AmountDue_Title'),
              message: this.getLabel('Account_Payment_Error_AmountDue_Message'),
              type: 'ERROR'
            });
          }
          this.isLoading = false;
        },
        error: () => this.isLoading = false
      });
  }

  validateMinDate(control: UntypedFormControl) {
    if (control?.value != null)
    {
      if (isAfter(new Date(), control.value)) {
        return { minDate: true };
      }
    }
  }

  validateCcv(control: UntypedFormControl) {
    if ((this.creditCardType === 'AMEX' && control.value?.length < 4) ||
        (this.creditCardType && control.value?.length < 3)) {
        return { invalid: true };
    }
  }

  onYearSelected(normalizedYear: any) {
    const ctrlValue = this.paymentFormGroup.get('ExpirationDate').value || new Date();
    ctrlValue.setYear(getYear(normalizedYear));
    this.paymentFormGroup.get('ExpirationDate').setValue(ctrlValue);
  }

  onMonthSelected(normalizedMonth: any, datepicker: any) {
    const ctrlValue = this.paymentFormGroup.get('ExpirationDate').value || new Date();
    ctrlValue.setMonth(getMonth(normalizedMonth));
    datepicker.close();
    this.paymentFormGroup.get('ExpirationDate').setValue(ctrlValue);
  }

  onAddressMapped($event: PlaceResult) {
    // to do - move to model file
    let streetNumber;
    let streetName;
    let postalCode;
    let city;
    let state;
    $event.address_components.forEach(value => {
      if (value.types.indexOf('street_number') > -1) {
        streetNumber = Number(value.short_name);
      }
      if (value.types.indexOf('route') > -1) {
        streetName = value.long_name;
      }
      if (value.types.indexOf('postal_code') > -1) {
        postalCode = Number(value.short_name);
      }
      if (value.types.indexOf('locality') > -1 || value.types.indexOf('sublocality_level_1') > -1) {
        city = value.long_name;
      }
      if (value.types.indexOf('administrative_area_level_1') > -1) {
        state = value.short_name;
      }
    });

    const addressLine1 = typeof streetNumber === 'undefined' ? streetName : streetNumber + ' ' + streetName;
    this.paymentFormGroup.get('BillingAddress1').setValue(addressLine1);
    if (Object.keys(city).length !== 0) {
      this.paymentFormGroup.get('City').setValue(city);
    }
    else {
      this.paymentFormGroup.get('City').setValue(null);
    }
    this.paymentFormGroup.get('State').setValue(state);
    if (postalCode !== undefined) {
      this.paymentFormGroup.get('ZipCode').setValue(`${postalCode}`.length === 4 ? '0' + `${postalCode}` : `${postalCode}`);
    }
    else {
      this.paymentFormGroup.get('ZipCode').setValue(null);
      this.paymentFormGroup.controls.ZipCode.markAsTouched();
    }
  }

  updatePaymentDetails() {
    this.isClicked = true;
    const consumer: MyAccountConsumer = {
      Name: this.paymentFormGroup.get('Name').value,
      Address1: this.paymentFormGroup.get('BillingAddress1').value,
      Address2: this.paymentFormGroup.get('BillingAddress2').value,
      City: this.paymentFormGroup.get('City').value,
      State: this.paymentFormGroup.get('State').value,
      Country: 'US',
      ZipCode: this.paymentFormGroup.get('ZipCode').value,
      Email: this.paymentInfoData.Email
    };
    const expDateM = this.paymentFormGroup.get('ExpirationDate').value;
    const expDate = new Date(expDateM);
    const paymentDetail: MyAccountPaymentDetail = {
      CardNumber: this.paymentFormGroup.get('CardNumber').value ? this.paymentFormGroup.get('CardNumber').value : undefined,
      AccountNumber: this.paymentFormGroup.get('AccountNumber').value,
      RoutingNumber: this.paymentFormGroup.get('RoutingNumber').value,
      CvcCode: this.paymentFormGroup.get('CvvCode').value ? parseInt(this.paymentFormGroup.get('CvvCode').value, 10) : undefined,
      ExpirationMonth: expDate.getMonth() + 1,
      ExpirationYear: expDate.getFullYear(),
      PaymentDay: expDate.getDate(),
      PinNumber: 0,
      ProfileStatus: 'Active',
      MoneyOrderNumber: ''
    };
    const request: UpdatePaymentDetailsRequest = {
      IsConsumerUpdated: true,
      IsPaymentDetailsUpdated: true,
      ContractNumber: this.selectedContract.id,
      PaymentPlanCode: PaymentPlanCode[this.paymentInfoData.PaymentPlanCode as keyof typeof PaymentPlanCode],
      Amount: this.paymentInfoData.TotalContractPriceWithTax,
      ClientId: this.clientId,
      AssociateNumber: this.associateNumber,
      ProgramCode: this.programCode,
      Consumer: consumer,
      RecurringAmount: this.paymentInfoData.TotalContractPriceWithTax,
      TrackingId: 'db7fac60-9f69-4415-b841-ca5d1c5ed3e1',
      PaymentType: 0, // this.paymentFormGroup.get('paymentType').value === 'eCheck' ? 1 : (this.paymentFormGroup.get('paymentType').value === 'CreditCard' ? 0 : undefined),
      PaymentDetail: paymentDetail
    };

    if (!this.paymentInfoData.IsAmountOverDue) {
      this.googleAnalyticsService.emitGTMEvent({
        event: GTMEvents.UpdatePayment,
        event_status: GTMApiStatus.Started
      });

      this.billingProfileDataService.updatePaymentDetails(request).subscribe({
        next: () => {
          this.updatePaymentMessageChange.emit({
            title: this.getLabel('Account_Payment_Error_UpdatePayment_Title'),
            message: this.getLabel('Account_Payment_Error_UpdatePayment_Message'),
            type: 'SUCCESS'
          });
          this.getBillingInfo();

          // Solved Card Number Invalid Validate issue after update
          setTimeout(() => {
            this.paymentFormGroup.get('CardNumber').setValidators(null);
            this.paymentFormGroup.get('CardNumber').clearValidators();
            this.paymentFormGroup.get('CardNumber').markAsUntouched();
          }, 500);
        },
        error: () => this.updatePaymentMessageChange.emit({
          title: this.getLabel('Global_Error'),
          message: this.getLabel('Global_Error_Processing_Request'),
          type: 'ERROR'
        })
      });
    } else {
      window.dataLayer = window.dataLayer || {};

      this.googleAnalyticsService.emitGTMEvent({
        event: GTMEvents.MakePayment,
        event_status: GTMApiStatus.Started
      });

      request.Amount = this.paymentInfoData.TotalContractPriceWithTax;

      this.billingProfileDataService.payOverDuePaymentDetails(request).subscribe({
        next: response => {
          if (response.AuthorizationCode) {
            this.updatePaymentMessageChange.emit({
              title: this.getLabel('Account_Payment_OverDue_Success_Title'),
              message: this.getLabel('Account_Payment_OverDue_Success_Message'),
              type: 'SUCCESS'
            });
            window.dataLayer.push({
              event: 'payOverDuePayment',
            });
          } else {
            this.updatePaymentMessageChange.emit({
              title: this.getLabel('Global_Error'),
              message: this.getLabel('Account_Payment_Error_Message'),
              type: 'ERROR'
            });
          }
        },
        error: () => this.updatePaymentMessageChange.emit({
          title: this.getLabel('Global_Error'),
          message: this.getLabel('Global_Error_Processing_Request'),
          type: 'ERROR'
        })
      });
    }
  }

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : "Account_Billing_Payment";
    let title = namespace + "_" + name;
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  getLabel(key: string) {
    return this.resourceService.getViewLabel(key);
  }
}
